/**
 * Focus on form element if not considered valid
 */
export function focusOnErroredFormElement(e: React.FormEvent<HTMLFormElement>) {
  const formElements = e?.target?.form?.elements || []

  for (const element of formElements) {
    const nativeValidationFailed = !element.checkValidity()
    const manualValidationFailed = element.ariaInvalid === 'true'

    if (nativeValidationFailed || manualValidationFailed) {
      element.focus()
      break
    }
  }
}
